import Icon from './Icon'
export default Icon

export * from './Icon'
